const dictionary: Record<string, string> = {
  id: "ID",
  userId: "ユーザーID",
  createdAt: "作成日付",
  updatedAt: "更新日付",
  status: "ステータス",
  desiredAmount: "調達希望額",
  companyName: "会社名",
  applicantName: "代表者名",
  applicantNameKana: "代表者フリガナ",
  corporateNumber: "法人番号",
  postalCode: "郵便番号",
  prefecture: "都道府県",
  city: "市区町村",
  address1: "番地",
  address2: "建物名／号室",
  isInvoiceIssued: "請求書発行",
  billingAmount: "請求金額",
  paymentDate: "入金日",
  images: "画像送信（請求書・口座履歴）",
  entries: "請求書情報",
  notification: "お知らせ",
  notificationDate: "お知らせ日付",
  requireAdditionalImages: "画像アップロードボタン表示",
  applicationNumber: "申込管理番号",
  applicationDate: "申込日",
  notes: "備考欄",
  personalInfoConsent: "個人情報登録の同意",
};

export function getJaDisplayName(varName: string): string {
  return dictionary[varName] || varName;
}
